// src/utils/leagueConfig.js
// Central configuration per league type.
// Supports both short keys ("5","7","9","11") and labels ("5-a-side", etc.)


export const LEAGUE_CONFIGS = {
  "5-a-side": {
    label: "5-a-side",
    minPlayers: 5,
    maxPlayers: 5,
    // squad / picking
    squadConfig: {
      minPlayers: 3,
      maxPlayers: 3,
      positions: ["DEF", "MID", "FWD"],
      positionRules: { DEF: { min: 0, max: 2 }, MID: { min: 0, max: 2 }, FWD: { min: 0, max: 2 } }, // cannot have all 3 from one position
    },
    budget: 18,
    maxFreeTransfers: 2,
    transferPenaltyPoints: 5,
    chipsEnabled: true,
    chips: ["Goal Boost", "Triple Captain", "Fortress"],
  },
  "7-a-side": {
    label: "7-a-side",
    minPlayers: 7,
    maxPlayers: 7,
    squadConfig: {
      minPlayers: 4,
      maxPlayers: 4,
      positions: ["DEF", "MID", "FWD"],
      positionRules: { DEF: { min: 1, max: 2 }, MID: { min: 1, max: 2 }, FWD: { min: 1, max: 2 } }, // min 1 per position, max 2
    },
    budget: 24,
    maxFreeTransfers: 2,
    transferPenaltyPoints: 5,
    chipsEnabled: true,
    chips: ["Goal Boost", "Triple Captain", "Fortress"],
  },
  "9-a-side": {
    label: "9-a-side",
    minPlayers: 9,
    maxPlayers: 9,
    squadConfig: {
      minPlayers: 5,
      maxPlayers: 5,
      positions: ["DEF", "MID", "FWD"],
      positionRules: { DEF: { min: 1, max: 3 }, MID: { min: 1, max: 3 }, FWD: { min: 1, max: 3 } }, // min 1 per position, max 3
    },
    budget: 29,
    maxFreeTransfers: 3,
    transferPenaltyPoints: 5,
    chipsEnabled: true,
    chips: ["Goal Boost", "Triple Captain", "Fortress"],
  },
  "11-a-side": {
    label: "11-a-side",
    minPlayers: 11,
    maxPlayers: 11,
    squadConfig: {
      minPlayers: 5,
      maxPlayers: 5,
      positions: ["DEF", "MID", "FWD"],
      positionRules: { DEF: { min: 1, max: 3 }, MID: { min: 1, max: 3 }, FWD: { min: 1, max: 3 } }, // min 1 per position, max 3
    },
    budget: 30,
    maxFreeTransfers: 3,
    transferPenaltyPoints: 5,
    chipsEnabled: true,
    chips: ["Goal Boost", "Triple Captain", "Fortress"],
  },
};

export function getLeagueConfig(type) {
  if (!type) return LEAGUE_CONFIGS["11-a-side"];

  // Normalize the input
  const normalized = String(type).trim().toLowerCase();

  // Explicit mapping for all variants
  const map = {
    "5": "5-a-side",
    "5-a-side": "5-a-side",
    "five": "5-a-side",
    "7": "7-a-side",
    "7-a-side": "7-a-side",
    "seven": "7-a-side",
    "9": "9-a-side",
    "9-a-side": "9-a-side",
    "nine": "9-a-side",
    "11": "11-a-side",
    "11-a-side": "11-a-side",
    "eleven": "11-a-side",
  };

  const resolved = map[normalized] || "11-a-side";
  return LEAGUE_CONFIGS[resolved];
}

export default getLeagueConfig;